<template>
    <div>
        <a-menu v-model="nav" mode="horizontal" @select="navChanged">
            <a-menu-item key="pages">
                <a-icon type="appstore"/>
                <span>页面设置</span>
            </a-menu-item>
            <a-menu-item key="guide">
                <a-icon type="compass"/>
                <span>引导页</span>
            </a-menu-item>
        </a-menu>
        <template v-if="config">
            <div v-if="nav[0] === 'pages' ">
                <m-tabs @serviceSortChange="serviceSortChange" @tabChange="tabChange" @preview="preview"
                        @change="saveChange" @miniChange="miniChange" :config="config"/>
            </div>
            <div v-else-if="nav[0] === 'guide' ">
                <m-guide @change="saveChange" @preview="preview" :config="config"/>
            </div>
            
            <div class="mp-container" v-if="config" style=" pointer-events: none; ">
                <a-affix :offset-top="120">
                    <mp v-if="showMp" ref="mp" :app-config="config" :serviceSort="serviceSort"/>
                </a-affix>
            </div>
        </template>
    </div>
</template>

<script>
import api from "@/repo/api";
import MTabs from "@/views/AST/Xcx/Items/MTabs.vue";
import MGuide from "@/views/AST/Xcx/Items/MGuide.vue";
import Mp from "@/views/AST/Xcx/Mp/Mp.vue";
import {useMpStore} from "@/views/AST/Xcx/Mp/mp";

export default {
    name: "Item",
    components: {Mp, MGuide, MTabs},
    data() {
        return {
            config: undefined,
            nav: ["pages"],
            serviceSort: '',
            showMp: true,
            defaultPage: "custom",
        }
    },
    setup() {
        const mpStore = useMpStore()
        return {mpStore}
    },
    mounted() {
        this.fetchConfig()
    },
    methods: {
        serviceSortChange(sort) {
            this.serviceSort = sort;
        },
        navChanged(nav) {
            if (this.$refs['mp']) {
                this.$refs['mp'].mini = false;
            }
            
            this.mpStore.setCurrentTabName((nav.key === 'guide') ? 'guide' : this.defaultPage);
        },
        miniChange(value) {
            if (this.$refs['mp']) {
                this.$refs['mp'].mini = value;
            }
        },
        tabChange(tab) {
            if (tab === 'card') {
                this.showMp = false;
            } else {
                this.showMp = true;
            }
            this.mpStore.setCurrentTabName(tab)
        },
        fetchConfig() {
            api.get('/ast-app/config', (data) => {
                
                if (data.code === 0) {
                    this.config = data.data;
                    this.serviceSort = this.config.page_service_sort;
                    this.mpStore.initConfig(this.config)
                }
                
            })
        },
        preview(group, config) {
            console.log(group, config);
            for (const configKey in config) {
                this.$set(this.config, configKey, config[configKey])
            }
            if (this.$refs['mp']) {
                this.$refs['mp'].init()
            }
        },
        saveChange(group, config) {
            
            this.$loading.show()
            
            api.post('/ast-app/save-config', {group, config}, () => {
                
                this.$loading.hide()
                
                if (group !== 'master-info') this.$message.success('已成功保存，手机端须重新进入小程序方可生效')
            })
            
        },
    }
}
</script>

<style scoped lang="less">
.mp-container {
    position: absolute;
    top: 220px;
    right: 10px;
}
</style>